import { render, staticRenderFns } from "./ConnectionCoach.vue?vue&type=template&id=2248ace4"
import script from "./ConnectionCoach.vue?vue&type=script&lang=js"
export * from "./ConnectionCoach.vue?vue&type=script&lang=js"
import style0 from "./ConnectionCoach.vue?vue&type=style&index=0&id=2248ace4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports